import React from "react";
import { Header } from "./Header/Header";
import Footer from "../Viewer/Header/Footer";
// import { Layout } from "../../styles/component/style";
import useViewer from "../../hooks/useViewer";
import styled from "styled-components";
import { Row } from "../Viewer/Header/Styles";
import { LogoutIcon, LogoutText } from "./Header/Styles";
import useAlert from "../../hooks/useAlert";
import AuthService from "../../services/AuthService";
import moment from "moment";
import { navigate } from "@reach/router";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../helpers/functions";

export default function TemporaryRoute({
  showSidebar = true,
  selectedItem,
  selectedSubItem,
  children,
}) {
  const role = localStorage.getItem("role");
  const { globalState, setGlobalState, userObject, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { enqueueSnackbar } = useSnackbar();

  const { galleryView } = globalState?.livepage || {};

  const shouldRenderAgmHeader =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : globalState?.general?.eventTemplate !== "AGM"
      ? true
      : globalState?.general?.eventTemplate === "AGM" &&
        !galleryView?.showHeader
      ? false
      : true;

  const shouldRenderAgmFooter =
    globalState?.general?.eventTemplate === "AGM" && galleryView?.showFooter
      ? true
      : globalState?.general?.eventTemplate !== "AGM"
      ? true
      : globalState?.general?.eventTemplate === "AGM" &&
        !galleryView?.showFooter
      ? false
      : true;

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);
      if (response?.status) {
        enqueueSnackbar("Logout successfully", {
          variant: "success",
        });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/login?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
        // setToken("logged_out");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        viewerLogout(userObject?.viewerId, "eventViewer");
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    <Layout
      image={globalState?.theme?.themeGeneral?.backgroundImage}
      bgColor={globalState?.theme?.themeGeneral?.bodyBackgroundColor}
      role={role}
    >
      {!shouldRenderAgmHeader && (
        <Row
          style={{ justifyContent: "flex-end", marginTop: "34px" }}
          onClick={handleLogout}
        >
          <LogoutIcon src={require("../../assets/images/logout.svg")} />
          <LogoutText>{"Sign Out"}</LogoutText>
        </Row>
      )}
      <Header
        {...{ showSidebar, selectedItem, selectedSubItem }}
        showHeader={shouldRenderAgmHeader}
      >
        {children}
      </Header>
      {shouldRenderAgmFooter && <Footer />}
    </Layout>
  );
}

export const Layout = styled.div`
  max-height: 100vh;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  background: ${({ image, bgColor }) =>
    image ? `url(${image}) no-repeat center center` : bgColor};
  background-size: cover;
`;
